<template>
    <v-col cols="12">
      <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
        <v-card tile class="mx-1">
          <v-card-title>
            <p>Manifestação da OSC</p> 
          </v-card-title>
          <v-card-subtitle>
            Espaço reservado para manifestação da OSC sobre o monitoramento recebido.
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="observacoes"
                    label="Observações da OSC sobre o Monitoramento"
                    filled
                    rows="3"
                    auto-grow
                    :rules="[(v) => !!v || 'Observações da OSC sobre o Monitoramento é obrigatório.']"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="mt-n4">
                <v-file-input
                  small-chips
                  multiple
                  label="Arquivo"
                  v-model="file"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-1 py-6">
            <v-btn type="submit" color="success text-center" small>{{ isUpdate ? "Salvar alterações" : "Salvar" }}</v-btn>
            <v-btn @click.prevent="cancel" color="error text-center" small>Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
</template>

<script>
import {mapActions} from "vuex";
import moment from 'moment'
moment.locale('pt')

export default {
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      observacoes: this.prestacaoConta.observacoesManifestacao,
      valid: true,
      errorMessage: "",
      file: null,
      dataMoment: moment(new Date()).format("DD/MM/YYYY"),
    };
  },
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },
    isUpdate() {
      return !!this.prestacaoConta.observacoesManifestacao;
    },
    titulo() {
      return this.isUpdate ? "Editar Manifestação" : "Cadastrar Manifestação" 
    },
    
  },
  methods: {
    ...mapActions('prestacaoConta', ['realizarManifestacao']),

    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((formulario) => {
          this.$refs.form.resetValidation()
          this.$emit("save", { formulario });
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    persist() {
      return this.create();
    },
    create() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        "prestacaoContaId": this.prestacaoConta.id,
        'observacoes': this.observacoes,
        'file': this.file ? this.file[0] : null 
      }
      
      return this.realizarManifestacao(payload)
    },
    cancel() {
      this.observacoes = this.prestacaoConta.observacoesManifestacao,
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
</style>
